<template>
  <section
    class="flex flex-col md:grid md:grid-rows-1 md:grid-cols-12 font-arial gap-4 xl:gap-0"
  >
    <img
      decoding="async"
      fetchpriority="high"
      width="312"
      height="365"
      :src="image"
      :alt="fullName || 'Rally Navigator team member'"
      sizes="(max-width: 312px) 100vw, 312px"
      class="md:col-span-4 m-auto"
      v-if="image"
    />
    <div class="md:col-span-8">
      <h2 class="font-russo text-[20px]">{{ fullName }}</h2>
      <ul class="flex flex-col gap-4 mt-4">
        <li class="font-black">
          <p>
            {{ description }}
          </p>
        </li>
        <li class="font-black text-[16px]">
          <p>
            {{ firstName + '&#8217;s ride:' }}
          </p>
        </li>
        <li class="font-black">
          <p v-if="rideLink" class="text-[#FF0000] hover:text-blue-500">
            <a :href="rideLink" target="_blank" rel="noopener noreferrer">
              {{ rideName }}
            </a>
          </p>
          <p v-else>{{ rideName }}</p>
        </li>
        <li class="font-black" v-if="contactCaption">
          <p>
            {{ contactCaption }}
          </p>
        </li>
        <li v-if="contact">
          <p class="text-[#FF0000] hover:text-blue-400">
            <a target="_blank" href="mailto:mike@rallynavigator.com">
              {{ contact }}
            </a>
          </p>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DeveloperRow',
  props: {
    image: String,
    fullName: String,
    firstName: String,
    description: String,
    contact: String,
    contactCaption: String,
    rideName: String,
    rideLink: String,
  },
};
</script>

<style scoped></style>
